export default {
    QUOTE: 'quote',
    INVOICE: 'invoice',
    CONTACT: 'contact',
    PAYMENTS: 'payments',
    APPOINTMENTS: 'meet',
    CHECKOUT_FORMS: 'checkout',
};
